// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1280":"97b3576b","1417":"6aa7ee76","3067":"268e1f16","4022":"97b3576b","5601":"a644dcc9","6533":"5fccd88b","6839":"97b3576b","8969":"97b3576b","9044":"d654f518","9355":"16ce6dfd"}[chunkId] + ".chunk.css";
};